var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53126 7.99058L12.7813 12.2406C13.075 12.5343 13.075 13.0093 12.7813 13.3L12.075 14.0062C11.7813 14.3 11.3063 14.3 11.0156 14.0062L8.00001 10.9968L4.98751 14.0093C4.69376 14.3031 4.21876 14.3031 3.92813 14.0093L3.21876 13.3031C2.92501 13.0093 2.92501 12.5343 3.21876 12.2437L7.46876 7.9937C7.76251 7.69683 8.23751 7.69683 8.53126 7.99058ZM7.46876 1.99058L3.21876 6.24058C2.92501 6.53433 2.92501 7.00933 3.21876 7.29995L3.92501 8.0062C4.21876 8.29995 4.69376 8.29995 4.98438 8.0062L7.99688 4.9937L11.0094 8.0062C11.3031 8.29995 11.7781 8.29995 12.0688 8.0062L12.775 7.29995C13.0688 7.0062 13.0688 6.5312 12.775 6.24058L8.52501 1.99058C8.23751 1.69683 7.76251 1.69683 7.46876 1.99058Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.33ffec353ccab2b8525ba926a458dd11.svg";
export { ForwardRef as ReactComponent };